/**
 * Onboarding Flow Utilities
 *
 * Pure utility functions for processing onboarding data.
 * No React hooks or state management - just data transformation.
 */

import {
  type EnrichedFactorStep,
  type FactorType,
} from '@/features/onboarding/types/onboarding.types';

/**
 * Extract list of enrolled factor types from flat factors array.
 * Used for enrolled factors summary and push enrollment check.
 */
export function getEnrolledFactors(
  factors: EnrichedFactorStep[]
): FactorType[] {
  return factors.filter(f => f.isEnrolled).map(f => f.factorType);
}
